__turbopack_context__.v({
  "cardCarousel": "TemplateCard-module-scss-module__b-0M1q__cardCarousel",
  "cardCarouselMobile": "TemplateCard-module-scss-module__b-0M1q__cardCarouselMobile",
  "cardContainer": "TemplateCard-module-scss-module__b-0M1q__cardContainer",
  "cardShadow": "TemplateCard-module-scss-module__b-0M1q__cardShadow",
  "fade": "TemplateCard-module-scss-module__b-0M1q__fade",
  "gif": "TemplateCard-module-scss-module__b-0M1q__gif",
  "gifHidden": "TemplateCard-module-scss-module__b-0M1q__gifHidden",
  "gifVisible": "TemplateCard-module-scss-module__b-0M1q__gifVisible",
  "hovered": "TemplateCard-module-scss-module__b-0M1q__hovered",
  "image": "TemplateCard-module-scss-module__b-0M1q__image",
  "logoBackground": "TemplateCard-module-scss-module__b-0M1q__logoBackground",
  "noBackgroundTemplate": "TemplateCard-module-scss-module__b-0M1q__noBackgroundTemplate",
  "skeletonLineStyle": "TemplateCard-module-scss-module__b-0M1q__skeletonLineStyle",
  "skeletonRectStyle": "TemplateCard-module-scss-module__b-0M1q__skeletonRectStyle",
  "template": "TemplateCard-module-scss-module__b-0M1q__template",
  "textColor": "TemplateCard-module-scss-module__b-0M1q__textColor",
});
